const types = {
  ALL_ADMINS_RESERVA_CARRROS: "@admins/ALL",
  ALL_ADMINS_VANS: "@admins/ALLVANS",
  UPDATE_ADMIN: "@admins/UPDATE",
  FILTER_ADMINS: "@admin/FILTER",
 ADD_ADMINS: "@admin/ADD",
 LOGIN_ADMIN_SESSION_IN: "@admin/LOGIN",
 LOGIN_SESSION_OUT: "@admin/LOGINOUT",
 CHECK_OUT: "@admin/CHECKOUT",
 ADD_ADMINS_TWO: "@admin/ADD",
  RESET_ADMINS: "@admin/RESET",
  UNLINK_ADMINS: "@admin/UNLINK",
};

export default types;
